var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"title"},[(_vm.quType)?_c('span',{staticClass:"label"},[_vm._v(_vm._s(_vm.quType==1?'单选':_vm.quType==2?'多选':_vm.quType==3?'判断':'default'))]):_vm._e(),_c('span',[_vm._v(_vm._s(_vm.title))])])}
var staticRenderFns = []

export { render, staticRenderFns }